import React, { Component } from 'react';
import UrbioticaTechMessagesModel from './UrbioticaTechMessagesModel';

import { Spin, Card, Col } from 'antd';
import moment from 'moment';

class UrbioticaInfrastructuresAktualTechInfos extends Component {
    state = {
        temperature: null,
        node_battery: null,
        timestamp: 0,
        resultDone: false,
    }
    componentWillMount() {
        if (this.props.infrastructureID) {
            UrbioticaTechMessagesModel.getLastMsgs(this.props.infrastructureID)
                .then((res) => {
                    this.setState({ resultDone: true })
                    res.map((item) => {
                        if (moment(item.stamps).isAfter(this.state.timestamp)) { this.setState({ timestamp: item.stamps }); }
                        if (item.phenomenonID == 'temperature') { this.setState({ temperature: item.measures + '°C' }); }
                        if (item.phenomenonID == 'node_battery') { this.setState({ node_battery: item.measures + 'V' }); }
                    });
                })
                .catch((err) => {
                    console.log(err);
                })
        }
    }

    render() {
        return (
            <React.Fragment>
                {!this.state.resultDone && <Spin />}
                {(this.state.temperature) && <Col span={2}><Card title="Teplota">{this.state.temperature}</Card></Col>}
                {(this.state.node_battery) && <Col span={3}><Card title="Napětí baterie">{this.state.node_battery}</Card></Col>}
                {this.state.timestamp != 0 && <Col span={4}><Card title='Čas poslední zprávy'>{moment(this.state.timestamp).format('L LTS')}</Card></Col>}
            </React.Fragment>
        );
    }

}

export default UrbioticaInfrastructuresAktualTechInfos


// WEBPACK FOOTER //
// ./src/components/UrbioticaInfrastructuresAktualTechInfos.js